import { CollapsibleKnowledgeCard } from "@/components/guide/CollapsibleKnowledgeCard";
import { CommunityCard } from "@/components/guide/CommunityCard";
import { getGlossary, sortCommunities } from "@/lib/content";
import type { CriterionId, GuideData } from "@/types/content";

import type { IntakeContactExtra } from "@/types/intake";

type Section4CommunitiesProps = {
  guide: GuideData;
  criterion: CriterionId | null;
  onIntakeContact: (extra?: IntakeContactExtra) => void;
};

export function Section4Communities({
  guide,
  criterion,
  onIntakeContact,
}: Section4CommunitiesProps) {
  const { housingTypes, roomTypes } = getGlossary();
  const sorted = sortCommunities(guide.communities, criterion);
  const topId = criterion && sorted.length > 0 ? sorted[0].id : null;

  return (
    <section className="pb-6 pt-8">
      <div className="px-5">
        <p className="kicker mb-3">第四段 · 给你的推荐</p>
        <h2 className="mb-2.5 text-2xl font-bold leading-tight tracking-tight text-ink-900">
          {criterion ? "按你的标准重新排过的小区" : "各片区值得看的小区"}
        </h2>
        <p className="text-[13.5px] leading-relaxed text-ink-600">
          {criterion
            ? "符合你偏好的排在最前,其余依然完整列出——多看一眼总没坏处。"
            : "上面选个偏好,我们就按那个标准给你排序。"}
        </p>

        <div className="mt-4 flex flex-col gap-3">
          <CollapsibleKnowledgeCard entry={housingTypes} />
          <CollapsibleKnowledgeCard entry={roomTypes} />
        </div>
      </div>

      <ul className="mt-5 flex flex-col gap-3 px-4">
        {sorted.map((c, i) => (
          <li key={c.id}>
            <CommunityCard
              community={c}
              regions={guide.regions}
              rank={i + 1}
              isTop={c.id === topId}
              criterion={criterion}
              onIntakeContact={onIntakeContact}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
